document.addEventListener("DOMContentLoaded", () => {
    const mobileBreakpoint = 960;
    const body = document.querySelector('body');
    const nav = document.querySelector('.main-navigation');
    if( nav ) {
        nav.classList.remove('hide');

        const menuToggle = document.querySelector('.menu-toggle');
        const topLevelItems = nav.querySelectorAll('.main-navigation__nav > li');
        const ddItems = nav.querySelectorAll('.main-navigation__nav > li.has-submenu');
        const subItems = nav.querySelectorAll('.submenu--first-level > ul > li.has-submenu');

        menuToggle.addEventListener('click', toggleNav);

        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && nav.classList.contains('active')) {
                toggleNav();
            }
        });

        const query = window.matchMedia(`(max-width: ${mobileBreakpoint}px)`);
        query.addEventListener("change", (e) => navHandleMQ(e.matches));
        navHandleMQ(query.matches);

        function toggleNav() {
            const isOpen = menuToggle.classList.toggle('active');

            nav.classList.toggle('active', isOpen);
            body.classList.toggle('nav-active', isOpen);
            body.classList.toggle('scroll-lock', isOpen);

            menuToggle.setAttribute('aria-expanded', isOpen);

            if (!isOpen) {
                resetAllClasses();
            }
        }


        function cloneSubMenu() {
            subItems.forEach((item) => {
                let itemID = item.getAttribute('data-submenu');
                let secondLevel = item.closest('.submenu-container').querySelector(`.submenu--second-level[data-submenu-id="${itemID}"]`);
                let clone = secondLevel.cloneNode(true);
                clone.classList.add('mobile');
                item.append(clone);
            });
        }

        function resetAllClasses() {
            nav.querySelectorAll('.show, .hide, .active').forEach((el) => {
                el.classList.remove('hide', 'show', 'active');
            });
        }

        function navHandleMQ(isMobile) {
            nav.classList.toggle('is-mobile', isMobile);
            nav.classList.toggle('is-desktop', !isMobile);

            if (isMobile) {
                // appendMobileToggleBtn();
                cloneSubMenu();
            }
            resetAllClasses();
        }

        // top level items - trigger drowpdown
        topLevelItems.forEach((item) => {
            if (nav.classList.contains('is-mobile')) {
                let navLink = item.querySelector('a');
                if (item.classList.contains('has-submenu')) {
                    // Keep the href attribute intact but prevent default navigation when clicked
                    navLink.addEventListener('click', (e) => {
                        e.preventDefault();
                        navLink.classList.toggle('active');
                        item.querySelector('.submenu--first-level').classList.toggle('show');
                    });
                }
            }
        });

        // Dropdown & subnavs
        ddItems.forEach((item) => {
            let firstLevel = item.querySelector('.submenu-container > div.submenu--first-level');
            let btnNext = item.querySelectorAll('.submenu--first-level ul li.has-submenu button');
            let btnBack = item.querySelectorAll('.submenu--second-level button.submenu__btn--back');

            btnNext.forEach((btn) => {
                function triggerSubmenu(el) {
                    el.addEventListener('click', () => {
                        let clickedItem = el.parentNode;
                        let targetMenuID = clickedItem.getAttribute('data-submenu');

                        if (nav.classList.contains('is-desktop')) {
                            firstLevel.classList.add('hide');
                            let secondLevel = item.querySelector(`.submenu-container > div.submenu--second-level[data-submenu-id="${targetMenuID}"]`);
                            secondLevel.classList.toggle('show');
                        }
                    });
                }
                
                triggerSubmenu(btn);
            });

            if (nav.classList.contains('is-mobile')) {
                item.addEventListener('click', (e) => {
                    firstLevel.querySelectorAll('li.has-submenu[data-submenu]').forEach((subItem) => {
                        subItem.addEventListener('click', (clickedItem) => {
                            // Check if the clicked item is not a secondLevel element
                            if (!clickedItem.target.closest('.submenu--second-level')) {
                                clickedItem.preventDefault();
                                clickedItem.stopPropagation();
            
                                let targetMenuID = subItem.getAttribute('data-submenu');
                                
                                let btnNext = subItem.querySelector('button.submenu__btn--next');
                                btnNext.classList.toggle('active');
                                let secondLevel = subItem.querySelector(`div.submenu--second-level[data-submenu-id="${targetMenuID}"]`);
                                secondLevel.classList.toggle('show');
                            }
                        });
                    });
                });
            }        

            btnBack.forEach((btn) => {
                btn.addEventListener('click', () => {
                    btn.closest('.submenu--second-level').classList.remove('show');
                    firstLevel.classList.remove('hide');
                });
            });
        });

        // SECONDARY NAV
        const secondaryNav = document.querySelector('.main-navigation__secondary-menu');
        if (secondaryNav) {
            const secondaryNavItems = secondaryNav.querySelectorAll('li.menu-item-has-children');
            
            function setupSecondaryNavMobile() {
                secondaryNavItems.forEach(item => {
                    const link = item.querySelector(':scope > a');
                    const subMenu = item.querySelector(':scope > ul.sub-menu');
                    
                    // Create arrow container
                    if (!item.querySelector('.secondary-nav-toggle')) {
                        const toggle = document.createElement('button');
                        toggle.className = 'secondary-nav-toggle';
                        toggle.innerHTML = '<span class="screen-reader-text">Toggle submenu</span>';
                        item.appendChild(toggle);
                        
                        // Handle arrow click
                        toggle.addEventListener('click', (e) => {
                            e.stopPropagation();
                            item.classList.toggle('active');
                            subMenu.style.display = item.classList.contains('active') ? 'block' : 'none';
                        });
                    }
                    
                    // Handle parent link click
                    if (link) {
                        link.addEventListener('click', (e) => {
                            if (window.innerWidth > mobileBreakpoint) return;
                            
                            // If clicking the arrow area, let the toggle button handle it
                            const arrowArea = item.querySelector('.secondary-nav-toggle');
                            if (arrowArea && arrowArea.contains(e.target)) {
                                e.preventDefault();
                                return;
                            }
                        });
                    }
                });
            }
            
            function resetSecondaryNavDesktop() {
                secondaryNavItems.forEach(item => {
                    const subMenu = item.querySelector(':scope > ul.sub-menu');
                    const toggle = item.querySelector('.secondary-nav-toggle');
                    
                    item.classList.remove('active');
                    if (subMenu) subMenu.style.display = '';
                    if (toggle) toggle.remove();
                });
            }
            
            const query = window.matchMedia(`(max-width: ${mobileBreakpoint}px)`);
            function handleSecondaryNavChange(e) {
                if (e.matches) {
                    setupSecondaryNavMobile();
                } else {
                    resetSecondaryNavDesktop();
                }
            }
            
            query.addEventListener("change", handleSecondaryNavChange);
            handleSecondaryNavChange(query);
        }
        
    }
});
